import { createActions, handleActions } from 'redux-actions';

const initState = {
  companies: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  ADMIN_GET_ALL_COMPANIES: (payload) => payload,
  ADMIN_SUCCESS: (payload) => payload,
  ADMIN_FAILURE: (payload) => payload,
});

const getAllCompaniesReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    ADMIN_GET_ALL_COMPANIES: getAllCompaniesReducer,
    ADMIN_SUCCESS: successReducer,
    ADMIN_FAILURE: failureReducer,
  },
  initState,
);
